<div class="h-[100%]">
  <mat-dialog-content class="!p-[0rem]">
    <div class="flex !bg-[#DEE2E6] h-[55px] sticky top-0 z-50 !justify-between">
    <h2
      class="!header  text-[#21252A] !font-semibold !text-[20px] pl-[20px] flex justify-left !items-center !text-center !m-0"
    >
      Print Preview
    </h2>
    <mat-icon class="!font-extrabold !text-[26px] cursor-pointer" (click)="closeDialog()">close</mat-icon>
  </div>
    <div id="projectBriefPlanView">
      <!-- Project Brief -->
      <div
        class="mt-[0px] m-[30px] pt-[20px] p-[25px] rounded-lg wrapper mb-[60px]"
      >
        <div class="flex justify-between">
          <div class="flex flex-col items-end">
            <div class="flex flex-col">
              <div class="flex">
                <h3 class="!m-0 title-value">{{ projectBriefData?.name }}</h3>
              </div>
              <div class="flex justify-start">
                <div class="title">Project Title</div>
              </div>
            </div>
          </div>
          <div>
            <img
              src="assets/images/logo.png"
              alt="logo"
              class="h-[78px] w-[78px] rounded-[7px]"
            />
          </div>
        </div>

        <div
          class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]"
        >
          <div class="w-[30%] p-[30px] project-attributes-container">
            <p class="site-condition">Intro</p>
            <div class="flex justify-start items-center">
              <p class="project-attribute">Project Type</p>
            </div>
            <p class="project-attribute-value">
              {{
                projectBriefData?.project_type?.parent
                  ? projectBriefData?.project_type?.parent?.name
                  : projectBriefData?.project_type?.name
              }}
            </p>

            <div>
              <div class="flex justify-start items-center">
                <p class="project-attribute">Project Sub Type</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.project_type?.name }}
              </p>
            </div>
          </div>
          <div class="w-[70%] flex flex-col justify-center">
            <div class="flex justify-start items-baseline">
              <p class="brief">Brief</p>
            </div>

            <p
              *ngIf="editField !== 'brief'"
              class="brief-value"
              [innerHTML]="getSanitizedHtml(projectBriefData?.description)"
            ></p>
          </div>
        </div>

        <div
          class="flex justify-start items-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]"
        >
          <div class="w-[29%] p-[30px] pt-[0px]">
            <p class="site-condition">Location and Site Conditions</p>

            <div class="mt-[12px]">
              <div class="flex justify-start items-center">
                <p class="project-attribute">Country</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.country?.name }}
              </p>
            </div>

            <div class="mt-[12px]">
              <div class="flex justify-start items-center">
                <p class="project-attribute">City</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.city }}
              </p>
            </div>

            <div class="mt-[12px]">
              <div class="flex justify-start items-center">
                <p class="project-attribute">Zip Code</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.zip }}
              </p>
            </div>

            <div class="mt-[12px]">
              <div class="flex justify-start items-center">
                <p class="project-attribute">Street</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.street }}
              </p>
            </div>

            <div class="mt-[12px]">
              <div class="flex justify-start items-center">
                <p class="project-attribute">Latitude</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.latitude }}
              </p>
            </div>

            <div>
              <div class="flex justify-start items-center">
                <p class="project-attribute">Longitude</p>
              </div>
              <p class="project-attribute-value !mb-[0px]">
                {{ projectBriefData?.longitude }}
              </p>
            </div>
          </div>

          <div class="flex-1 flex items-start">
            <div class="flex flex-col">
              <div class="flex justify-start items-baseline">
                <p class="brief">Site Conditions</p>
              </div>

              <p
                class="brief-value"
                [innerHTML]="
                  getSanitizedHtml(projectBriefData?.site_conditions)
                "
              ></p>
            </div>
          </div>
          <div class="flex-1 flex items-center">
            <iframe
              width="100%"
              height="244px"
              style="border: 0"
              loading="lazy"
              [src]="mapLink"
            >
            </iframe>
          </div>
        </div>

        <div class="flex justify-start gap-[50px] w-[100%] mt-[20px]">
          <div class="w-[29%]"></div>

          <div class="flex-1 flex items-center">
            <div class="">
              <div class="flex justify-start items-center">
                <p class="site-images">Site images</p>
              </div>
              <app-gallery
                [uploadedFiles]="uploadedFiles"
                [isEdit]="isImagesEdit"
              ></app-gallery>
              <div class="flex justify-start items-center">
                <p class="site-images !mt-[18px]">Documents</p>
              </div>
              <app-gallery
                [uploadedFiles]="DocumentFiles"
                [isEdit]="isDocumentsEdit"
              ></app-gallery>
            </div>
          </div>
        </div>

        <div
          class="flex justify-start gap-[50px] w-[100%] mt-[20px] min-h-[228px]"
        >
          <div class="w-[29%] p-[30px] project-attributes-container">
            <div class="flex justify-start">
              <div class="key-deliverable">Key Deliverables</div>
            </div>
          </div>

          <div class="flex-1 flex items-start mt-[30px]">
            <ul class="!pl-0" *ngIf="editField !== 'keyDeliverable'">
              <div *ngFor="let keyword of projectBriefData?.goals" class="flex">
                <div class="flex">
                  <span class="h-[22px] mr-[10px]">{{ keyword.name }}</span>
                </div>
              </div>
            </ul>
          </div>
        </div>

        <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
          <div class="w-[29%] p-[30px]">
            <div class="key-deliverable mb-[6px]">Budget</div>
            <div>
              <div class="flex justify-start items-center">
                <p class="project-attribute">Grade</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.grade?.name }}
              </p>
            </div>

            <div class="flex justify-start items-center">
              <p class="project-attribute">GMP Enabled</p>
            </div>
          </div>

          <div class="flex-1 flex flex-col items-start w-[100%]">
            <div class="w-[90%]">
              <div class="flex justify-between flex-col">
                <div class="flex justify-between items-center">
                  <div>
                    <div class="mt-[12px]">
                      <div class="flex justify-start items-center">
                        <p class="milestone-header">Total Allocated</p>
                      </div>

                      <p class="milestone-value !mb-[10px]">
                        {{
                          projectBriefData?.budget
                            ? projectBriefData?.country?.symbol
                            : "--"
                        }}{{
                          projectBriefData?.budget
                            ? projectBriefData?.budget.amount
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="w-[515px] flex justify-start">
                    <div class="mt-[34px] mb-[34px]">
                      <p class="milestone-value !mb-[10px]">
                        <ng-container>
                          {{
                            projectBriefData?.budget &&
                            projectBriefData?.budget.amount
                              ? (numberToWords(projectBriefData?.budget.amount)
                                | titlecase)
                              : ""
                          }}
                        </ng-container>
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Risk and Contigency Amount -->
                <div
                  *ngIf="
                    projectBriefData?.budget &&
                    projectBriefData?.budget.risk_and_contengency_amount &&
                    projectBriefData?.budget?.gmp
                  "
                  class="flex justify-between items-center"
                >
                  <div>
                    <div class="mt-[12px]">
                      <div class="flex justify-start items-center">
                        <p class="milestone-header">Risk & Contingency</p>
                        <img
                          src="assets/icons/pencil.svg"
                          alt="pencil"
                          class="ml-[10px] h-[12px] cursor-pointer"
                        />
                      </div>

                      <p class="milestone-value !mb-[10px]">
                        {{ projectBriefData?.country?.symbol }}
                        {{
                          projectBriefData?.budget.risk_and_contengency_amount
                        }}
                      </p>
                    </div>
                  </div>

                  <div class="w-[515px] flex justify-start">
                    <div class="mt-[34px] mb-[34px]">
                      <p class="milestone-value !mb-[10px]">
                        <ng-container
                          *ngIf="
                            projectBriefData?.budget
                              .risk_and_contengency_amount &&
                            projectBriefData?.budget.risk_and_contengency_amount
                          "
                        >
                          {{
                            numberToWords(
                              projectBriefData?.budget
                                .risk_and_contengency_amount
                            ) | titlecase
                          }}
                        </ng-container>
                      </p>
                    </div>
                  </div>
                </div>
                <!-- GMP Amount -->
                <div
                  *ngIf="
                    projectBriefData?.budget &&
                    projectBriefData?.budget.gmp_amount &&
                    projectBriefData?.budget?.gmp
                  "
                  class="flex justify-between items-center"
                >
                  <div>
                    <p class="milestone-header">GMP Amount</p>
                    <p class="milestone-value !mb-[10px]">
                      {{ projectBriefData?.country?.symbol }}
                      {{ projectBriefData?.budget.gmp_amount }}
                    </p>
                  </div>

                  <div class="w-[515px] flex justify-start">
                    <div class="mt-[34px] mb-[34px]">
                      <p class="milestone-value !mb-[10px]">
                        <ng-container
                          *ngIf="
                            projectBriefData?.budget &&
                            projectBriefData?.budget.gmp_amount
                          "
                        >
                          {{
                            numberToWords(projectBriefData?.budget.gmp_amount)
                              | titlecase
                          }}
                        </ng-container>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
          <div class="w-[29%] p-[30px] project-attributes-container">
            <div class="key-deliverable mb-[6px]">Milestones</div>
            <div>
              <div class="flex justify-start items-center">
                <p class="project-attribute">Project Start Date</p>
              </div>
              <p class="project-attribute-value">
                {{ projectBriefData?.start_date | date : "yyyy-MM-dd" }}
              </p>
            </div>

            <div>
              <div class="flex justify-start items-center">
                <p class="project-attribute">Project End Date</p>
              </div>
              <p class="project-attribute-value !mb-[0px]">
                {{ projectBriefData?.end_date | date : "yyyy-MM-dd" }}
              </p>
            </div>
          </div>

          <div
            class="flex-1 flex flex-col items-start mt-[30px] justify-start w-[100%]"
          >
            <div class="w-[90%]">
              <div class="flex items-center justify-flex-start">
                <div class="w-1/3">
                  <p class="milestone-header">Description</p>
                </div>
                <div class="w-1/3">
                  <p class="milestone-header">From</p>
                </div>
                <div class="w-1/3">
                  <p class="milestone-header">To</p>
                </div>
              </div>
            </div>

            <div
              *ngFor="let milestone of projectBriefData?.mile_stones"
              class="w-[90%]"
            >
              <div
                class="w-[100%]"
                *ngIf="milestone.id !== selectedMileStoneId"
              >
                <div class="flex items-center justify-flex-start">
                  <div class="w-1/3">
                    <p class="milestone-value !mb-[10px]">
                      {{ milestone?.name }}
                    </p>
                  </div>
                  <div class="w-1/3">
                    <p class="milestone-value !mb-[10px]">
                      {{ milestone?.start_date }}
                    </p>
                  </div>
                  <div class="w-1/3">
                    <p class="milestone-value !mb-[10px] flex justify-start">
                      <span> {{ milestone?.end_date }} </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-start gap-[50px] w-[100%] !mb-[70px]">
          <div class="w-[29%] p-[30px] flex justify-start items-start">
            <div class="flex justify-start items-center">
              <div class="key-deliverable">Stakeholders</div>
            </div>
          </div>

          <div class="flex-1 flex flex-col items-start justify-start mt-[30px]">
            <div>
              <div *ngFor="let stakeholder of projectBriefData?.stake_holders">
                <p class="project-attribute1">
                  {{ stakeholder?.stake_holder }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <app-approval-status-view
          [projectId]="projectId"
          [stage]="PROJECT_STAGE?.STAGE_1"
        ></app-approval-status-view>
      </div>

      <!-- Project Plan -->

      <div class="wrapper mt-[0px] m-[30px] pt-[43px] p-[25px]">
        <div class="mb-8">
          <div
            class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]"
          >
            <div class="w-[30%] p-[30px] project-attributes-container">
              <h1>Measurement Standards and <br />Work Packages</h1>
            </div>
            <div class="w-[70%] flex flex-col justify-center">
              <h1 class="measurement-header">NRM</h1>
              <h3 class="measurement-calculations-head">
                Total Work Packages - {{ total_work_packages }}
              </h3>
              <h3 class="measurement-calculations-head">
                Total Estimated Cost -
                {{ country?.symbol ? country?.symbol : "$" }}
                {{ total_cost }}
              </h3>
            </div>
          </div>
          <table
            class="min-w-full bg-[#fcfcfd] table-auto border-collapse border-gray-200"
          >
            <thead
              class="h-[50px] bg-[#ececec] text-[#000000] !text-center justify-center"
            >
              <tr>
                <th class="border border-gray-300 px-4 py-2 text-left">Name</th>
                <th class="border border-gray-300 px-4 py-2 text-left">
                  Cost Estimate
                </th>
                <th class="border border-gray-300 px-4 py-2 text-left">
                  Responsible
                </th>
                <th class="border border-gray-300 px-4 py-2 text-left">
                  Accountable
                </th>
                <th class="border border-gray-300 px-4 py-2 text-left">
                  Consulted
                </th>

                <th class="border border-gray-300 px-4 py-2 text-left">
                  Informed
                </th>
                <th
                  class="border border-gray-300 px-4 py-2 text-left pl-[2.25rem]"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let workPackage of projectPlanResponsibilityData?.project_work_package
                "
                class="hover:bg-gray-50"
              >
                <td class="border border-gray-300 px-4 py-2">
                  {{ workPackage.work_package?.name }}
                </td>
                <td class="border border-gray-300 px-4 py-2">
                  <input
                    class="bg-[#F9FAFB]"
                    [value]="workPackage?.cost_estimate"
                    currencyMask
                    [options]="{
                      prefix: country?.symbol ? country?.symbol : '$',
                      suffix: '',
                      thousands: ',',
                      allowZero: false,
                      decimal: '',
                      precision: 0,
                      nullable: true,
                      align: 'left',
                      max: 100000000000,
                    }"
                    disabled
                  />
                </td>

                <td class="border border-gray-300 px-4 py-2">
                  {{ workPackage.responsible === 'undefined' ? '' : workPackage.responsible }}
                </td>
                <td class="border border-gray-300 px-4 py-2">
                  {{ workPackage.accountable  === 'undefined' ? '' : workPackage.accountable}}
                </td>
                <td class="border border-gray-300 px-4 py-2">
                  {{ workPackage.consulted  === 'undefined' ? '' : workPackage.consulted}}
                </td>
                <td class="border border-gray-300 px-4 py-2">
                  {{ workPackage.informed === 'undefined' ? '' : workPackage.informed }}
                </td>
                <td class="border text-center border-gray-300 px-4 py-2">
                  <span>&#8942;</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-8 mt-[50px]">
          <div
            class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]"
          >
            <div class="w-[30%] p-[30px] project-attributes-container">
              <h1>Risk Register</h1>
            </div>
            <div class="w-[70%] flex flex-col justify-center">
              <h3 class="measurement-calculations-head">
                Total No. Identified Risks - {{ number_of_risks }}
              </h3>
              <h3 class="measurement-calculations-head">
                Average = {{ average_risks }}, Medium = {{ moderate_risks }},
                High =
                {{ high_risks }}
              </h3>
            </div>
          </div>

          <div>
            <table
              class="min-w-full table-auto bg-[#fcfcfd] border-collapse border border-gray-200"
            >
              <thead class="h-[50px] bg-[#ececec] text-[#000000] !text-center">
                <tr>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Risk Description
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Risk Category
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Likelihood
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Impact
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Risk Rating
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Mitigation Strategy
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Owner
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Date
                  </th>
                  <th class="border border-gray-300 px-4 py-2 text-left">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody class="">
                <tr
                  *ngFor="let risk of projectPlanRiskRegisterData"
                  class="hover:bg-gray-50"
                >
                  <td class="border border-gray-300 px-4 py-2">
                    {{ risk.description }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2 text-center">
                    {{ risk.risk_category_id }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2 text-center">
                    {{ risk.likelihood }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2 text-center">
                    {{ risk.impact }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2 text-center">
                    {{ risk.risk_rating }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2">
                    {{ risk.mitigation_strategy }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2">
                    {{ risk.risk_owner }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2">
                    {{ risk.target_resolution_date }}
                  </td>
                  <td class="border border-gray-300 px-4 py-2">
                    <span
                      [ngClass]="{
                        'text-green-500  px-2 py-1 rounded':
                          risk.status === 'Active',
                        'text-red-500  px-2 py-1 rounded':
                          risk.status === 'Rejected',
                        'text-yellow-500  px-2 py-1 rounded':
                          risk.status === 'Approved',
                        'text-gray-500 px-2 py-1 rounded':
                          risk.status === 'Inactive'
                      }"
                    >
                      {{ risk.status }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <app-approval-status-view
          [projectId]="projectId"
          [stage]="PROJECT_STAGE?.STAGE_2"
        ></app-approval-status-view>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button (click)="handleCloseDialog()" class="mr-[1.875rem] close-btn">
      Close
    </button>
    <button (click)="print()" class="print-button mr-[1.5rem]">Print</button>
  </mat-dialog-actions>
</div>
